// GENERATED FILE, PLEASE DO NOT EDIT
var None = 0;
var Small = 4;
var Medium = 8;
var Large = 16;
var XLarge = 24;
var BorderRadiusTokensAll = {
  Large: Large,
  Medium: Medium,
  None: None,
  Small: Small,
  XLarge: XLarge
};

export { BorderRadiusTokensAll, Large, Medium, None, Small, XLarge, BorderRadiusTokensAll as default };
